import { IScope, IWindowService } from "angular";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { TeamFuturesRecord } from "../../interfaces/team-futures-record.interface";
import { GeneralService } from "../../services/general.service";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

export class FuturesMiniController {

	configurationObject: BlockConfigurationObject;
	displayMode = "full";
	displayMaximumWidths = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
	};
	futuresError = false;
	futuresLoading = true;
	futuresMarket = {
		name: "winner"
	};
	futuresSport: string;
	futuresTeamLimit = 4;
	futuresTeams = [];
	generalService: GeneralService;
	matchService: MatchService;

	_$scope: IScope;
	_$window: IWindowService;
	// _Rollbar: any;
	_sportDataService: SportDataService;

	/* @ngInject */
	constructor($scope: IScope, /*Rollbar: any,*/ $window: IWindowService, configurationObject: BlockConfigurationObject,
		matchService: MatchService, sportDataService: SportDataService, generalService: GeneralService) {
		this.generalService = generalService;
		this.futuresSport = configurationObject.sportCode.toUpperCase();
		this.configurationObject = configurationObject;
		this.matchService = matchService;

		this._$scope = $scope;
		this._$window = $window;
		// this._Rollbar = Rollbar;
		this._sportDataService = sportDataService;

		if (this.configurationObject.teamLimit) {
			this.futuresTeamLimit = this.configurationObject.teamLimit;
		}

		generalService.initialiseBlock();
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});
	
		$window.addEventListener("resize", this.checkCompact);


		matchService.getGeoData().then(() => {
			this.retrieveFutures();
		}, () => {
			this.retrieveFutures();
		});
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}

	futuresMorePrompt = (): string => {
		// TODO special cases for some sports
		return `All ${this.generalService.getShortName(this.futuresSport)} Futures`;
	}

	seasonRecord = (team: TeamFuturesRecord, sport: string): string => {
		if (typeof team.Wins === "undefined" || typeof team.Losses === "undefined") {
			return "";
		}

		if (sport === "NHL") {
			return `${team.Wins}-${team.RegLosses}-${team.OtLosses}`;
		}

		if (this.generalService.isSoccer(sport)) {
			return "";
			// return `${team.Wins}-${team.Ties}-${team.Losses}`;
		}

		if (!team.Ties) {
			return `${team.Wins}-${team.Losses}`;
		}

		return `${team.Wins}-${team.Losses}-${team.Ties}`;
	}

	probabilityNumber = (team: TeamFuturesRecord, market: string): number => {
		if (team && team.FuturesMarkets && team.FuturesMarkets.some(m => m.Name === market)) {
			const marketObj = team.FuturesMarkets.find(m => m.Name === market);

			if (marketObj.Probability) {
				return marketObj.Probability;
			}
		}

		return 0;
	}

	teamSort = (a: {value: TeamFuturesRecord}, b: {value: TeamFuturesRecord}): number => {
		return this.probabilityNumber(b.value, this.futuresMarket.name) - this.probabilityNumber(a.value, this.futuresMarket.name);
	}

	retrieveFutures = (): void => {
		this.futuresLoading = true;
		this.futuresError = false;

		this._sportDataService.getFuturesTeams(this.futuresSport)
			.then((teams) => {
				this.futuresTeams = teams;
				
				this.futuresLoading = false;
			})
			.catch((err) => {
				if (err !== "API_CALL_FAILED") {
					// this._Rollbar.error(err);
					console.error(err);
				}
				this.futuresError = true;
			});
	}
}